import { fmhAPI, INTAKE_CASE_API_URL } from 'api/APIBase';

export async function getIntakeCaseFile({
    intakeCaseId,
    intakeCaseClinicalFileId,
    filename,
}: {
    intakeCaseId: string;
    intakeCaseClinicalFileId: string;
    filename: string;
}) {
    const url = `${INTAKE_CASE_API_URL}/intake_cases/${intakeCaseId}/files/${intakeCaseClinicalFileId}`;
    return fmhAPI.base
        .url(url)
        .get()
        .blob((blob) => new File([blob], filename, { type: blob.type }));
}

export async function getIntakeSourceFile({ intakeSourceId }: { intakeSourceId: string }) {
    const url = `${INTAKE_CASE_API_URL}/intake_sources/${intakeSourceId}`;
    return fmhAPI.base
        .url(url)
        .get()
        .blob((blob) => new File([blob], 'fax.pdf', { type: blob.type }));
}
